// 兼容 IE
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babelpolyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { noticeUniappHandler, calculateDistance } from '@/utils/index';
import { getCollectList } from '@/api/map';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// 设置webuni
import webUni from '../public/js/uni.webview.1.5.4';
Vue.prototype.$webUni = webUni;

// 设置 js中可以访问 $cdn
import { $cdn } from '@/config';
Vue.prototype.$cdn = $cdn;

// 全局引入按需引入UI库 vant
import '@/plugins/vant';
// 引入全局样式
import '@/assets/css/index.scss';
// 移动端适配
import 'amfe-flexible';

// filters
import './filters';
Vue.config.productionTip = false;
let isCanBak = false;
router.afterEach(() => {
  isCanBak = true;
});
// 返回上一页
Vue.prototype.$back = () => {
  // let path = router.history.current.path
  // if (window.history.length > 1 && !(path == '/search' || path == '/charge')) {
  if (window.history.length > 1) {
    router.back();
  } else {
    noticeUniappHandler({
      type: 'h5',
      msg: 'back'
    });
  }
  // 解决依据 window.history.length 判断返回length只增不减 无法返回上一页问题
  setTimeout(() => {
    if (!isCanBak) noticeUniappHandler({
      type: 'h5',
      msg: 'back'
    });
    isCanBak = false;
  }, 200);
};
const vmAPP = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  async created() {
    webUni.webView.postMessage({
      data: {
        type: 'connect',
        msg: true
      }
    });
  },
  methods: {
    test(data) {
      var _window, _window$android;
      let json = {
        a: 1,
        b: 2
      };
      (_window = window) === null || _window === void 0 ? void 0 : (_window$android = _window.android) === null || _window$android === void 0 ? void 0 : _window$android.back(JSON.stringify(json));
      console.log('h5-test', data);
    },
    // 跳转对应页面
    jumpPage(path, query) {
      // console.log('jumpPage', path, query)
      this.$router.replace({
        path: path,
        query: {
          ...query,
          refresh: true
        }
      });
    },
    handleLocationShares(data) {
      store.dispatch('map/setLocationShares', data);
    },
    handleXdData(data) {
      // localStorage.setItem('xdData', JSON.stringify(data))
      console.log('h5-handleXdData=====', JSON.stringify(data));
      localStorage.setItem('xdData', data);
    },
    changeAmapNaviState(data) {
      console.log('h5-changeAmapNaviState=====', typeof data, JSON.stringify(data));
      let temp = JSON.parse(data);
      store.dispatch('map/setAmapNaviState', temp.amapNaviState);
      // store.dispatch('map/setNaviStep', temp.naviStep)
    },

    updateMapStorage(key, value) {
      // const { key, value } = data
      // let whiteKeys = ['searchHistory']
      // if (whiteKeys.includes(key)) {
      //   localStorage.setItem(key, JSON.stringify(value))
      // }
      // console.log('updateMapStorage', JSON.stringify(value))
      console.log(`updateMapStorage-${key}`, value === null || value === void 0 ? void 0 : value.length);
      if (key === 'searchHistory') {
        store.dispatch('map/setHistoryList', value);
      } else if (key === 'collectData') {
        store.dispatch('app/setCollectData', value);
        // console.log('app/setCollectData', value)
      } else if (key === 'chargingStation') {
        store.dispatch('app/setChargingStation', value);
        // console.log('app/setChargingStation', value)
      } else if (key === 'shopPois') {
        store.dispatch('app/setShopPois', value);
      } else if (key === 'poiInfo') {
        if (value) localStorage.setItem('poiInfo', JSON.stringify(value));
      } else if (key === 'webUrl') {
        store.dispatch('app/setWebUrl', value.url);
      }
    },
    setExitLock() {
      store.dispatch('map/setExitLock', true);
    },
    exitNavi() {
      var _store$getters$routeP, _store$getters$routeP2;
      console.log('h5-exitNavi=====');
      let segments = (_store$getters$routeP = store.getters.routePath) === null || _store$getters$routeP === void 0 ? void 0 : (_store$getters$routeP2 = _store$getters$routeP.transits[0]) === null || _store$getters$routeP2 === void 0 ? void 0 : _store$getters$routeP2.segments;
      let naviStep = store.getters.naviStep;
      let exitLock = store.getters.exitLock;
      let outdoors = segments.filter(v => v.routetype === 0 || v.routetype === 2) || [];
      let {
        lon,
        lat
      } = outdoors[0].endpoint;
      let xdData = JSON.parse(localStorage.getItem('xdData')) || {};
      let distance = 0;
      if (xdData.lng > 0) {
        distance = calculateDistance(lon, lat, xdData.lng, xdData.lat);
      }
      console.log('h5-exitNavi====', `exitLock: ${exitLock}; naviStep: ${naviStep},segments.length:${segments.length}, distance: ${distance}`);
      // distance有可能因为小于30导致无法正常切换，滤值改成80
      if (exitLock || segments.length > naviStep && distance < 100) return console.log('h5-exitNavi====', '阻止');
      router.go(-1);
    },
    reCalculateAmapRoute() {
      console.log('h5-reCalculateAmapRoute===== start');
      // 记录当前路径
      localStorage.setItem('previousRoutePath', JSON.stringify(store.getters.routePath));
      // 重新计算高德路线  室外-室内切换
      let locationInfo = store.getters.locationInfo || {};
      let mapOptions = store.getters.mapOptions || {};
      let endPoint = JSON.parse(localStorage.getItem('endPoint'));
      let poiInfo = JSON.parse(localStorage.getItem('poiInfo'));
      let startPoint = {
        bdid: locationInfo.isGps == 1 ? '' : mapOptions.buildingId,
        floorId: locationInfo.isGps == 1 ? '' : mapOptions.floorId,
        lon: locationInfo.lon,
        lat: locationInfo.lat
      };
      window.getRoutePath({
        startPoint,
        endPoint: endPoint ? endPoint : poiInfo
      });
      window.reCalculateAmapRoute();
      console.log('h5-reCalculateAmapRoute===== end');
    },
    setLastNaviChargeId(data) {
      let dataTemp = JSON.parse(data);
      let lastNaviChargeId = dataTemp.lastNaviChargeId;
      window.sTime = setTimeout(() => {
        if (window.sTime) {
          clearTimeout(window.sTime);
          window.sTime = null;
          return;
        }
        store.dispatch('app/setLastNaviChargeId', lastNaviChargeId);
        console.log('h5-setLastNaviChargeId=====', lastNaviChargeId);
      }, 1000);

      // localStorage.setItem('lastNaviChargeId', lastNaviChargeId)
    },

    async setUserToken(data) {
      let dataTemp = JSON.parse(data);
      let XdToken = dataTemp.token;
      let uid = dataTemp.uid;
      console.log('h5-getUserXdToken=====', typeof data, data);
      console.log('h5-getUserXdToken=====', dataTemp.token);
      store.dispatch('app/setUserId', uid);
      store.dispatch('app/setUserXdToken', XdToken);
      if (XdToken) {
        let params = {
          user_id: uid
        };
        let res = await getCollectList(params);
        if (res.code === 200) {
          store.dispatch('app/setCollectList', res.data);
        }
      }
    }
  }
});
window.vmAPP = vmAPP;